import { css } from "styled-components";
import { ThemeProp } from "styles/theme";

export const antdTabsStyles = css`
  .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }: ThemeProp) => theme.highlight};
  }
`;
